import React from 'react';
import { FadeIn } from './ui/FadeIn';
const upsellComparisons = [{
  situation: 'Querés saber de dónde viene la humedad',
  bad: 'Suposición',
  good: 'Test del Espejo + Test de Napa + Árbol de Decisión',
  best: 'Diagnóstico guiado con herramienta de casos especiales'
}, {
  situation: 'Vas a comprar los materiales',
  bad: 'Te venden de más o de menos',
  good: 'Lista de materiales del sistema',
  best: 'Calculadora Cero Desperdicio con cantidad exacta'
}, {
  situation: 'Empezás la inyección',
  bad: 'No sabés por dónde empezar',
  good: 'Módulo 2 completo paso a paso',
  best: 'Diario de Obra 21 días — solo seguís el día de hoy'
}, {
  situation: 'Algo sale diferente en la obra',
  bad: 'Pánico y parás',
  good: 'Revisás el módulo correspondiente',
  best: 'Protocolo de Emergencia: 5 casos con solución paso a paso'
}, {
  situation: 'Terminás la obra',
  bad: 'No sabés si funcionó',
  good: 'Checklist de verificación del Módulo 2',
  best: 'Prueba de Agua documentada + Expediente Técnico completo'
}, {
  situation: 'Querés mantener el resultado',
  bad: 'Sin sistema de seguimiento',
  good: 'Módulo 4 completo',
  best: 'Calendario anual + 7 Indicadores de Alerta Temprana'
}];
export function UpsellSection() {
  return <section className="py-10 md:py-12 px-4 bg-slate-950 text-center border-t border-slate-800/50" data-id="element-300">
      <div className="max-w-5xl mx-auto" data-id="element-301">
        <FadeIn data-id="element-302">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-303">
            🔩 ¿QUÉ AGREGA EL PASAPORTE DEL MAESTRO?
          </h2>
          <p className="text-xl text-slate-400 mb-8" data-id="element-304">
            Mismo problema de humedad, dos realidades distintas según lo que
            tengas
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-305">
          <div className="bg-slate-900 rounded-2xl border border-slate-700 overflow-hidden shadow-xl mb-10 text-left" data-id="element-306">
            <div className="overflow-x-auto" data-id="element-307">
              <table className="w-full min-w-[800px]" role="table" aria-label="Comparación con y sin Pasaporte del Maestro" data-id="element-308">
                <thead data-id="element-309">
                  <tr className="bg-slate-950 border-b border-slate-700" data-id="element-310">
                    <th scope="col" className="p-5 text-left text-slate-300 font-bold w-1/4" data-id="element-311">
                      Situación en tu casa
                    </th>
                    <th scope="col" className="p-5 text-left text-red-500 font-bold border-l border-slate-700 w-1/4" data-id="element-312">
                      <span aria-hidden="true" data-id="element-313">❌</span> Sin sistema
                    </th>
                    <th scope="col" className="p-5 text-left text-green-500 font-bold border-l border-slate-700 w-1/4" data-id="element-314">
                      <span aria-hidden="true" data-id="element-315">✅</span> Con Sistema Humedad
                      Cero
                    </th>
                    <th scope="col" className="p-5 text-left text-orange-500 font-bold border-l border-slate-700 w-1/4 bg-orange-500/5" data-id="element-316">
                      <span aria-hidden="true" data-id="element-317">🥇</span> + Pasaporte del Maestro
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-800" data-id="element-318">
                  {upsellComparisons.map((row, i) => <tr key={i} data-id="element-319">
                      <td className="p-5 text-slate-300 font-medium" data-id="element-320">
                        {row.situation}
                      </td>
                      <td className="p-5 text-slate-400 text-sm border-l border-slate-800" data-id="element-321">
                        {row.bad}
                      </td>
                      <td className="p-5 text-white font-bold text-sm border-l border-slate-800" data-id="element-322">
                        {row.good}
                      </td>
                      <td className="p-5 text-orange-400 font-bold text-sm border-l border-slate-800 bg-orange-500/5" data-id="element-323">
                        {row.best}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-324">
          <div className="text-center mb-6" data-id="element-325">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-white tracking-wide" data-id="element-326">
              ✅ ¿QUÉ INCLUYE CADA UNO?
            </h3>
            <p className="text-slate-400 mt-2" data-id="element-327">
              Todo lo que entra dentro de cada opción
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto text-left" data-id="element-328">
            {/* Sistema Base Features */}
            <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6" data-id="element-329">
              <h4 className="text-xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-330">
                💧 SISTEMA HUMEDAD CERO
              </h4>
              <p className="text-slate-400 text-sm mb-6 pb-4 border-b border-slate-800" data-id="element-331">
                Incluido en ambas opciones
              </p>

              <ul className="space-y-3 text-sm text-slate-300" data-id="element-332">
                <li className="font-bold text-white mt-4" data-id="element-333">
                  ✓ Módulo 1 — El Diagnóstico Maestro (50 páginas)
                </li>
                <li className="pl-4 text-slate-400" data-id="element-334">
                  ✓ Test del Espejo + Test de la Napa
                </li>
                <li className="pl-4 text-slate-400" data-id="element-335">
                  ✓ Mapa de Daño + Árbol de Decisión
                </li>

                <li className="font-bold text-white mt-4" data-id="element-336">
                  ✓ Módulo 2 — La Barrera Química (50 páginas)
                </li>
                <li className="pl-4 text-slate-400" data-id="element-337">
                  ✓ Geometría exacta de perforación
                </li>
                <li className="pl-4 text-slate-400" data-id="element-338">
                  ✓ Protocolo de 3 cargas de inyección
                </li>
                <li className="pl-4 text-slate-400" data-id="element-339">
                  ✓ Verificación y sellado final
                </li>

                <li className="font-bold text-white mt-4" data-id="element-340">
                  ✓ Módulo 3 — La Protección Exterior (50 páginas)
                </li>
                <li className="pl-4 text-slate-400" data-id="element-341">
                  ✓ 8 Puntos Críticos del techo
                </li>
                <li className="pl-4 text-slate-400" data-id="element-342">
                  ✓ Membrana en frío sin equipos especiales
                </li>
                <li className="pl-4 text-slate-400" data-id="element-343">
                  ✓ Sellado de juntas y fisuras exteriores
                </li>
                <li className="pl-4 text-slate-400" data-id="element-344">
                  ✓ Pintura reflectante paso a paso
                </li>

                <li className="font-bold text-white mt-4" data-id="element-345">
                  ✓ Módulo 4 — El Mantenimiento Inteligente (50 páginas)
                </li>
                <li className="pl-4 text-slate-400" data-id="element-346">
                  ✓ Calendario estacional de revisiones
                </li>
                <li className="pl-4 text-slate-400" data-id="element-347">
                  ✓ Los 7 Indicadores de Alerta Temprana
                </li>
                <li className="pl-4 text-slate-400" data-id="element-348">
                  ✓ Expediente Técnico de la propiedad
                </li>

                <li className="font-bold text-white mt-4" data-id="element-349">
                  ✓ Bono #1 — Checklist Express de Ferretería
                </li>
                <li className="font-bold text-white" data-id="element-350">
                  ✓ Bono #2 — Guía de Inspección por Ambiente
                </li>
                <li className="font-bold text-white" data-id="element-351">
                  ✓ Bono #3 — Mini Manual de Errores Tontos
                </li>
              </ul>
            </div>

            {/* Pasaporte del Maestro Features */}
            <div className="bg-[#1A365D] border border-orange-500/50 rounded-2xl p-6 relative overflow-hidden" data-id="element-352">
              <div className="absolute top-0 right-0 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-353">
                EL MÁS ELEGIDO
              </div>
              <h4 className="text-xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-354">
                🔧 PASAPORTE DEL MAESTRO
              </h4>
              <p className="text-orange-300 text-sm mb-6 pb-4 border-b border-orange-500/30" data-id="element-355">
                Solo en la opción completa
              </p>

              <ul className="space-y-4 text-sm text-slate-200" data-id="element-356">
                <li className="flex gap-2" data-id="element-357">
                  <span className="text-orange-400 font-bold" data-id="element-358">✓</span>
                  <span data-id="element-359">
                    <strong data-id="element-360">Calculadora Cero Desperdicio</strong> (3 datos →
                    lista exacta de compras)
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-361">
                  <span className="text-orange-400 font-bold" data-id="element-362">✓</span>
                  <span data-id="element-363">
                    <strong data-id="element-364">Diario de Obra de 21 Días</strong> (hoja de ruta día
                    por día)
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-365">
                  <span className="text-orange-400 font-bold" data-id="element-366">✓</span>
                  <span data-id="element-367">
                    <strong data-id="element-368">Guía de Marcas y Precios</strong> Actualizada
                    Argentina
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-369">
                  <span className="text-orange-400 font-bold" data-id="element-370">✓</span>
                  <span data-id="element-371">
                    <strong data-id="element-372">Protocolo de Emergencia</strong> (5 casos frecuentes
                    con solución)
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-373">
                  <span className="text-orange-400 font-bold" data-id="element-374">✓</span>
                  <span data-id="element-375">
                    <strong data-id="element-376">La Anti-Estafa del Corralón</strong>
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-377">
                  <span className="text-orange-400 font-bold" data-id="element-378">✓</span>
                  <span data-id="element-379">
                    <strong data-id="element-380">Ficha de registro de tratamiento</strong> para el
                    Expediente Técnico
                  </span>
                </li>
                <li className="flex gap-2" data-id="element-381">
                  <span className="text-orange-400 font-bold" data-id="element-382">✓</span>
                  <span data-id="element-383">
                    <strong data-id="element-384">Certificado de obra completada</strong>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}